import i18n from "../i18n";

export const adventures = [
  {
    key: "mongolia",
    url: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_landing.mp4",
    get title() {
      return i18n.t("landing.checkout_featured.adventures.mongolia.title");
    },
    get caption() {
      return i18n.t("landing.checkout_featured.adventures.mongolia.caption");
    },
    link: "https://www.sotravel.com/all-trips?broad=360",
  },
  {
    key: "ski",
    url: "https://d1puf2nnbcyl9q.cloudfront.net/ski_landing.mp4",
    get title() {
      return i18n.t("landing.checkout_featured.adventures.ski.title");
    },
    get caption() {
      return i18n.t("landing.checkout_featured.adventures.ski.caption");
    },
    link: "https://www.sotravel.com/all-trips?broad=snow",
  },
  {
    key: "rinjani",
    url: "https://d1puf2nnbcyl9q.cloudfront.net/rinjani_landing.mp4",
    get title() {
      return i18n.t("landing.checkout_featured.adventures.rinjani.title");
    },
    get caption() {
      return i18n.t("landing.checkout_featured.adventures.rinjani.caption");
    },
    link: "https://www.sotravel.com/all-trips?broad=land",
  },
  {
    key: "dive",
    url: "https://d1puf2nnbcyl9q.cloudfront.net/dive_landing.mp4",
    get title() {
      return i18n.t("landing.checkout_featured.adventures.dive.title");
    },
    get caption() {
      return i18n.t("landing.checkout_featured.adventures.dive.caption");
    },
    link: "https://www.sotravel.com/all-trips?broad=dive",
  },
  {
    key: "surf",
    url: "https://d1puf2nnbcyl9q.cloudfront.net/surf_landing.mp4",
    get title() {
      return i18n.t("landing.checkout_featured.adventures.surf.title");
    },
    get caption() {
      return i18n.t("landing.checkout_featured.adventures.surf.caption");
    },
    link: "https://www.sotravel.com/all-trips?broad=surf",
  },
];

export const companyReviews = [
  {
    key: "today",
    review: "“For Gen Zs & Millennials itching for an unique adventure”",
    imageSrc: "/landing/today-company.png",
  },
  {
    key: "cna",
    review: "“Expand your social network in an authentic and fun way”",
    imageSrc: "/landing/channel-newsasia.png",
  },
  {
    key: "asia_one",
    review: `"A passion project that's shaking up the travel industry"`,
    imageSrc: "/landing/asia-one.png",
  },
  {
    key: "business_insider",
    review: `"Probably the most affordable & unique tours in the market"`,
    imageSrc: "/landing/business-insider.png",
  },
];

export const faqs = [
  {
    key: "what_included",
    get question() {
      return i18n.t("landing.faqs.questions.what_included.question");
    },
    get answer() {
      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t("landing.faqs.questions.what_included.answer_title")}
          </p>
          <p>{i18n.t("landing.faqs.questions.what_included.answer_detail")}</p>
        </p>
      );
    },
  },
  {
    key: "cancellation",
    get question() {
      return i18n.t("landing.faqs.questions.cancellation.question");
    },
    get answer() {
      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t("landing.faqs.questions.cancellation.answer_title")}
          </p>
          <p>{i18n.t("landing.faqs.questions.cancellation.answer_detail")}</p>
        </p>
      );
    },
  },
  {
    key: "travel_insurance",
    get question() {
      return i18n.t("landing.faqs.questions.travel_insurance.question");
    },
    get answer() {
      return (
        <>
          <p>
            <p className="tw-font-bold tw-mb-2">
              {i18n.t("landing.faqs.questions.travel_insurance.answer_title1")}
            </p>
            <p>
              {i18n.t("landing.faqs.questions.travel_insurance.answer_detail1")}
            </p>
          </p>{" "}
          <p>
            <p className="tw-font-bold tw-mb-2 tw-mt-2">
              {i18n.t("landing.faqs.questions.travel_insurance.answer_title2")}
            </p>
            <p>
              {i18n.t("landing.faqs.questions.travel_insurance.answer_detail2")}
            </p>
          </p>
        </>
      );
    },
  },
  {
    key: "people_join",
    get question() {
      return i18n.t("landing.faqs.questions.people_join.question");
    },
    get answer() {
      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t("landing.faqs.questions.people_join.answer_title")}
          </p>
          <p>{i18n.t("landing.faqs.questions.people_join.answer_detail")}</p>
        </p>
      );
    },
  },
  {
    key: "introverts",
    get question() {
      return i18n.t("landing.faqs.questions.introverts.question");
    },
    get answer() {
      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t("landing.faqs.questions.introverts.answer_title")}
          </p>
          <p>{i18n.t("landing.faqs.questions.introverts.answer_detail")}</p>
        </p>
      );
    },
  },
  {
    key: "guide_leader",
    get question() {
      return i18n.t("landing.faqs.questions.guide_leader.question");
    },
    get answer() {
      return (
        <>
          <p>
            <p className="tw-font-bold tw-mb-2">
              {i18n.t("landing.faqs.questions.guide_leader.answer_title")}
            </p>
            <p>{i18n.t("landing.faqs.questions.guide_leader.answer_detail")}</p>
          </p>
        </>
      );
    },
  },
  {
    key: "book_flights",
    get question() {
      return i18n.t("landing.faqs.questions.book_flights.question");
    },
    get answer() {
      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t("landing.faqs.questions.book_flights.answer_title")}
          </p>
          <p>{i18n.t("landing.faqs.questions.book_flights.answer_detail")}</p>
        </p>
      );
    },
  },
];

export const whyChooseUs = [
  {
    key: "community",
    get title() {
      return i18n.t("landing.why_choose_us.reasons.community.title");
    },
    get description() {
      return i18n.t("landing.why_choose_us.reasons.community.description", {
        returnObjects: true,
      });
    },
    thumbnailSrc: "/landing/meet-likeminded.png",
    reviewer: {
      name: "Clarice Yeo",
      profilePictureSrc: "/landing/clarice-yeo.png",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.4) 77.26%)",
  },
  {
    key: "itinerary",
    get title() {
      return i18n.t("landing.why_choose_us.reasons.itinerary.title");
    },
    get description() {
      return i18n.t("landing.why_choose_us.reasons.itinerary.description", {
        returnObjects: true,
      });
    },
    thumbnailSrc: "/landing/unique-and-packed.png",
    reviewer: {
      name: "Shannon Tan",
      profilePictureSrc: "/landing/tan-shannon.png",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 21.05%, rgba(0, 0, 0, 0) 29.88%, rgba(0, 0, 0, 0) 68.91%, rgba(0, 0, 0, 0.5) 81.27%)",
  },
  {
    key: "adventures",
    get title() {
      return i18n.t("landing.why_choose_us.reasons.adventures.title");
    },
    get description() {
      return i18n.t("landing.why_choose_us.reasons.adventures.description", {
        returnObjects: true,
      });
    },
    thumbnailSrc: "/landing/hard-to-do-alone.jpeg",
    reviewer: {
      name: "Kimberly Tham",
      profilePictureSrc: "/landing/kimberly-tham.png",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.29) 15.56%, rgba(0, 0, 0, 0) 23.15%, rgba(0, 0, 0, 0) 69.8%, rgba(0, 0, 0, 0.58) 74.58%)",
  },
  {
    key: "stress_free",
    get title() {
      return i18n.t("landing.why_choose_us.reasons.stress_free.title");
    },
    get description() {
      return i18n.t("landing.why_choose_us.reasons.stress_free.description", {
        returnObjects: true,
      });
    },
    thumbnailSrc: "/landing/zero-planning.jpeg",
    reviewer: {
      name: "Kent Lin",
      profilePictureSrc: "/landing/kent-lin.png",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.312) 18.89%, rgba(0, 0, 0, 0) 33.94%, rgba(0, 0, 0, 0) 53.36%, rgba(0, 0, 0, 0.468) 75.46%)",
  },
];

export const adventurerReviews = [
  {
    key: "nicolette",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/988209IMG_2363.jpg",
    reviewTo: "Nicolette",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.nicolette.review");
    },
    reviewFrom: "Lynn",
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.ap-southeast-1.amazonaws.com/1694246144308_blob.jpeg",
    tripName: "Mongolia",
  },
  {
    key: "olivia",
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1716916179704_blob.jpeg",
    reviewTo: "Olivia",
    reviewFrom: "Dion",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.olivia.review");
    },
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1714648713505_blob.jpeg",
    tripName: "Indonesia",
  },
  {
    key: "martin",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/838244image_2024-12-03_21-46-06.png",
    reviewTo: "Martin",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.martin.review");
    },
    reviewFrom: "Shi Zheng",
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1717684151409_blob.png",
    tripName: "Bali",
  },
  {
    key: "christalle",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/383509dac3826138cbad4d600f6a01f1ade0bb.png",
    reviewTo: "Christalle",
    reviewFrom: "Kyli",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.christalle.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.amazonaws.com/1712114972710_blob.jpeg",
    tripName: "The French Alps",
  },
  {
    key: "wilfred",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/158857photo_2023-05-28_06-26-42.jpg",
    reviewTo: "Wilfred",
    reviewFrom: "Jia Wei",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.wilfred.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/50170tQz2gr4m_WUjfpl4TySIeexJPsU65lVdWjuelfr4uj0MfawqBTBrIgj8CMGgQQegVshSLd1zhgGmdEgy5Skn1JvfJHkSCdlPzc0fujsB0gkdwOin9xIiH4Uhypvf3pBtAlaVeasvV4cHmTz9acC7DnTHgAQPVlRCu4r_CDNWGRb8otO8C9qiMzSng1Lzg9r8t7XT70s6kmYvgIkfcdL7Ym9bDfG7LEStVSECZDeqDNuR37vo.jpg",
    tripName: "China",
  },
  {
    key: "emmalyn",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1286924IMG_2365.jpg",
    reviewTo: "Emmalyn",
    reviewFrom: "Larry",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.emmalyn.review");
    },
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1722276134007_blob.jpeg",
    tripName: "a light house",
  },
  {
    key: "jolynn",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/884895image_2024-12-04_16-41-10.png",
    reviewTo: "Jolynn",
    reviewFrom: "Pansy",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.jolynn.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.amazonaws.com/1702823503300_blob.jpeg",
    tripName: "Philippines",
  },
  {
    key: "evan",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/164510photo_2024-04-10_22-28-55.jpg",
    reviewTo: "Evan",
    reviewFrom: "Azreena",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.evan.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/136265photo_2024-11-10_23-37-39.jpg",
    tripName: "Europe",
  },
  {
    key: "erica",
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1731372276095_blob.jpeg",
    reviewTo: "Erica",
    reviewFrom: "Guan Yew",
    get review() {
      return i18n.t("landing.meet_featured.reviews.sg.erica.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.ap-southeast-1.amazonaws.com/1708540998398_blob.jpeg",
    tripName: "Japan",
  },
];
export const adventurerReviewsMy = [
  {
    key: "shinn",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_3.png",
    reviewTo: "Shinn",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.shinn.review");
    },
    reviewFrom: "Shi Zheng",
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1717684151409_blob.png",
    tripName: "Everest Base Camp",
  },
  {
    key: "jia_cheng",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_1.png",
    reviewTo: "Jia Cheng",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.jia_cheng.review");
    },
    reviewFrom: "Lynn",
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.ap-southeast-1.amazonaws.com/1694246144308_blob.jpeg",
    tripName: "Mt Kinabalu",
  },
  {
    key: "zheng_wei",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_8.png",
    reviewTo: "Zheng Wei (Tai)",
    reviewFrom: "Azreena",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.zheng_wei.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/136265photo_2024-11-10_23-37-39.jpg",
    tripName: "Mt Kinabalu",
  },
  {
    key: "wei_hao",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_6.png",
    reviewTo: "Wei Hao",
    reviewFrom: "Larry",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.wei_hao.review");
    },
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1722276134007_blob.jpeg",
    tripName: "Jade Mountain",
  },
  {
    key: "shu_hua",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_4.png",
    reviewTo: "Shu Hua",
    reviewFrom: "Kyli",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.shu_hua.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.amazonaws.com/1712114972710_blob.jpeg",
    tripName: "Beijing Ski Trip",
  },
  {
    key: "edward",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_7.png",
    reviewTo: "Edward",
    reviewFrom: "Pansy",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.edward.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.amazonaws.com/1702823503300_blob.jpeg",
    tripName: "Mulu Pinnacles",
  },
  {
    key: "karlson",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_9.png",
    reviewTo: "Karlson",
    reviewFrom: "Guan Yew",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.karlson.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-uploads.s3.ap-southeast-1.amazonaws.com/1708540998398_blob.jpeg",
    tripName: "Everest Base Camp",
  },
  {
    key: "sing_rui",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_5.png",
    reviewTo: "Sing Rui",
    reviewFrom: "Jia Wei",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.sing_rui.review");
    },
    reviewFromProfilePictureSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/50170tQz2gr4m_WUjfpl4TySIeexJPsU65lVdWjuelfr4uj0MfawqBTBrIgj8CMGgQQegVshSLd1zhgGmdEgy5Skn1JvfJHkSCdlPzc0fujsB0gkdwOin9xIiH4Uhypvf3pBtAlaVeasvV4cHmTz9acC7DnTHgAQPVlRCu4r_CDNWGRb8otO8C9qiMzSng1Lzg9r8t7XT70s6kmYvgIkfcdL7Ym9bDfG7LEStVSECZDeqDNuR37vo.jpg",
    tripName: "Annapurna",
  },
  {
    key: "frankie",
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/avider_leader_2.png",
    reviewTo: "Frankie",
    reviewFrom: "Dion",
    get review() {
      return i18n.t("landing.meet_featured.reviews.my.frankie.review");
    },
    reviewFromProfilePictureSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/1714648713505_blob.jpeg",
    tripName: "Mt Rinjani",
  },
];
